import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { TopicLeaf } from '../../model/TopicLeaf';
import { CoursewareService } from '../../services/CoursewareService';
import { Router } from '@angular/router';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';
import { LazyImagesComponent } from '../shared/lazy-images-component';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class BlogsComponent extends LazyImagesComponent implements OnInit, OnDestroy {
  public shortVideos: TopicLeaf[];
  public static cacheShortVideos: TopicLeaf[];
  public currentTopic: TopicLeaf = null;
  public breadcrumbs: Breadcrumb[] = [];
  public area: string = "/blogentryview";


  constructor(private canonicalService: MetaService, private titleService: Title, private coursewareService: CoursewareService, private _router: Router, private alertService: AlertService) {
    super();
    this.getShortVideos();
    this.titleService.setTitle("LawShelf's Blog - Lawshelf Educational Media")
  }

  ngOnDestroy() {
    this.canonicalService.removeCanonicalURL();
  }

  getShortVideos() {
    this.pushAllAds(2);
    if (!BlogsComponent.cacheShortVideos) {
      this.coursewareService.getBlogs().subscribe(data => {
        this.shortVideos = BlogsComponent.cacheShortVideos = data;
        if (!this.shortVideos || !this.shortVideos.length) {
          this.shortVideos = BlogsComponent.cacheShortVideos = null;
          let error: Error = data;
          this.alertService.error(error.Message);
        }
        this.totalImages = this.shortVideos.length;
      });
    }
    else
      this.shortVideos = BlogsComponent.cacheShortVideos;
  }

  hasShortVideos() {
    if (this.shortVideos == null || this.shortVideos.length < 1)
      return false;
    return true;
  }

  ngOnInit() {
    this.breadcrumbs = [{ Title: "Short-Videos", URL: "/shortvideosview" }, { Title: "LawShelf Blog", URL: "/blogsview" }];
    this.canonicalService.createCanonicalURL(this._router.url, "/blogview/");
  }
}
